export default __webpack_public_path__ + "static/media/ground.80f1e25e.svg";